<template>
	<span>
		<b-button
			@click="showEvidence"
			v-if="statusIsValid"
			size="sm"
			variant="warning"
			class="ml-1 mr-1"
			v-b-tooltip.hover
			title="Evidencias"
			> <md-icon icon="upload"/>  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info" v-if="showTotalFiles>0">{{showTotalFiles}}</span>
		</b-button>
		<b-modal
			hide-footer
			ref="show-evidence"
			size="lg"
			:title="`Evidencias de estado: ${label}`"
		>
			<FilesRelated
				:model-id="id"
				model-reference="transport-services"
				:unable-edit="false"
				:cols="3"
				:file-keys="fileKeys"
				@update:counter="(totalFiles)=>setTotalFiles(totalFiles)"

			/>
		</b-modal>
	</span>
</template>

<script>
import FilesRelated from "@/components/helpers/FilesRelated";
export default {
	components: {
		FilesRelated
	},
	data: () => ({
		fileKeys: [{ label: "Evidencias", keyName: "changeStatusEvidence[]" }],
		auxTotalFiles:null
	}),
	props: {
		id: Number,
		status: String,
		label: String,
		qtyFiles:Number
	},
	computed: {
		statusIsValid() {
			return this.status !== "active" && this.status !== "pending";
		},
		showTotalFiles(){
			if(this.auxTotalFiles!== null) return this.auxTotalFiles
			if(this.qtyFiles) return this.qtyFiles
			return 0
		}
	},
	methods: {
		showEvidence() {
			this.$refs["show-evidence"].show();
		},
		setTotalFiles(totalFiles){
			try{
				let auxTotalFiles   = totalFiles.find((item)=>{
					return item.key === "changeStatusEvidence[]";
				})
				this.auxTotalFiles = auxTotalFiles.count;
			}catch(err){
				console.log(err)
				this.auxTotalFiles = 0;
			}
		}
	}
};
</script>
